import { Component } from '@angular/core';
import { SharedModule } from '../../../../shared/shared.module';
import { CommonModule } from '@angular/common';
import { PurchaseOrder, PurchaseOrderGridResponse, gridPageRequest, gridPagination } from '../../../../model/common/common.model';
import { ConfirmationService, MessageService } from 'primeng/api';
import { Router } from '@angular/router';
import { PurchaseorderService } from '../../../../services/purchaseorder.service';
import _ from 'lodash';

@Component({
  selector: 'app-receive-purchaseorder-list',
  standalone: true,
  imports: [SharedModule,CommonModule],
  templateUrl: './receive-purchaseorder-list.component.html',
  styleUrl: './receive-purchaseorder-list.component.scss'
})
export class ReceivePurchaseorderListComponent {


  selectedPOrder: PurchaseOrder[]=[];

  constructor(private route: Router , private porderservice: PurchaseorderService,private confirmationService:ConfirmationService,
    private messageService:MessageService) {
  }

  loader: boolean =  false

  result: PurchaseOrderGridResponse = {
    purchaseOrder: [],
    totalRecords: 0
  }
  gridPagination: gridPagination = {
    first: 0,
    last: 0,
    totalRecords: 10
  }
  pageRequest: gridPageRequest = {
    pageIndex: 0,
    pageSize: 20,
    id: 0
  }

  ngOnInit(): void {
    this.getPurchaOrder(this.pageRequest)
  }

  getPurchaOrder(data: gridPageRequest) {
    this.loader = true;
    // this.porderservice.getPurchaseOrdersbySubmitted(data).subscribe({
    //   next: (data: any) => {
    //     this.result = data as PurchaseOrderGridResponse;
    //     this.pageCalculation()
    //     this.loader = false;
    //   },
    //   error: error => {
    //     this.loader = false;
    //     console.log(error);
    //   }
    // })
  }

  deletePOrder() {
    this.confirmationService.confirm({
      header: 'Are you sure?',
      message: 'Please confirm to proceed.',
      accept: () => {
        if (this.selectedPOrder && this.selectedPOrder.length > 0) {
          var purchaseOrderId = _.map(this.selectedPOrder, 'purchaseOrderId');
          this.porderservice.deletePurchaseOrder(purchaseOrderId).subscribe({
            next: () => {
              this.selectedPOrder = [];
              this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Deleted successfully.' });
              this.getPurchaOrder(this.pageRequest);
            },
            error: () => {

            }
          });
        }
      },
      reject: () => {
      }
  });

  }

  editPOrder(data?:any) {
    if(data){
      this.route.navigate(['/home/recievePurchaseOrder'], { queryParams: { 'purchaseOrderId': data }, skipLocationChange: false },);
    }else{
      this.route.navigate(['/home/recievePurchaseOrder'], { queryParams: { 'purchaseOrderId': this.selectedPOrder[0].purchaseOrderId }, skipLocationChange: true },);
    }
  }




  pageCalculation() {
    let last = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + this.pageRequest.pageSize;
    this.gridPagination.first = (this.pageRequest.pageIndex * this.pageRequest.pageSize) + 1;
    this.gridPagination.last = last < this.result.totalRecords ? last : this.result.totalRecords;
    this.gridPagination.totalRecords = this.result.totalRecords;
  }

  loadPOrder(event: any) {
    this.pageRequest.pageSize = this.pageRequest.pageSize + event.first + 5;
    this.getPurchaOrder(this.pageRequest);
  }


}
